import { useState } from 'react';
import { Link } from 'react-router-dom';
import Wordmark from '../components/Wordmark';
import api from '../api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Request failed');
    }
    setSubmitting(false);
  };

  const labelStyle = {
    display: 'block',
    fontFamily: '"Geist", "Inter", system-ui, sans-serif',
    fontSize: '12px',
    color: 'rgba(237,228,211,0.38)',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    marginBottom: '8px',
  };

  const inputStyle = {
    width: '100%',
    background: 'transparent',
    border: '1px solid rgba(237,228,211,0.08)',
    borderRadius: '6px',
    padding: '12px 16px',
    color: '#ede4d3',
    fontSize: '15px',
    fontFamily: '"Geist", "Inter", system-ui, sans-serif',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
  };

  const focusIn = e => { e.currentTarget.style.borderColor = '#e8b547'; };
  const focusOut = e => { e.currentTarget.style.borderColor = 'rgba(237,228,211,0.08)'; };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0e0a08',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
    }}>
      <div style={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

        {/* Wordmark */}
        <div style={{ marginBottom: '48px' }}>
          <Wordmark amber />
        </div>

        {/* Heading */}
        <h1 style={{
          fontFamily: '"Instrument Serif", serif',
          fontSize: '28px',
          fontWeight: 400,
          color: '#ede4d3',
          margin: '0 0 8px 0',
        }}>
          Reset password
        </h1>

        <p style={{
          fontFamily: '"Geist", "Inter", system-ui, sans-serif',
          fontSize: '14px',
          color: 'rgba(237,228,211,0.62)',
          margin: '0 0 40px 0',
          textAlign: 'center',
        }}>
          Enter your email and we'll send a reset link.
        </p>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <h2 style={{
              fontFamily: '"Instrument Serif", serif',
              fontSize: '22px',
              fontWeight: 400,
              color: '#ede4d3',
              margin: '0 0 12px 0',
            }}>Check your email</h2>
            <p style={{
              fontFamily: '"Geist", "Inter", system-ui, sans-serif',
              fontSize: '14px',
              color: 'rgba(237,228,211,0.62)',
              lineHeight: 1.6,
              margin: '0 0 24px 0',
            }}>
              If that email is registered, we've sent a reset link. Check your inbox.
            </p>
            <Link to="/login" style={{
              color: '#e8b547',
              fontSize: '13px',
              fontFamily: '"Geist", "Inter", system-ui, sans-serif',
              textDecoration: 'none',
            }}>
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            {/* Error */}
            {error && (
              <div style={{
                width: '100%',
                padding: '12px 16px',
                marginBottom: '24px',
                color: '#d47e6a',
                fontSize: '13px',
                fontFamily: '"Geist", "Inter", system-ui, sans-serif',
                border: '1px solid rgba(212,126,106,0.2)',
                borderRadius: '6px',
                background: 'rgba(212,126,106,0.06)',
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <div style={{ marginBottom: '28px' }}>
                <label style={labelStyle}>Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  style={inputStyle}
                  onFocus={focusIn}
                  onBlur={focusOut}
                />
              </div>

              <button
                type="submit"
                disabled={submitting}
                style={{
                  width: '100%',
                  border: '1px solid #e8b547',
                  background: 'rgba(232,181,71,0.16)',
                  color: '#e8b547',
                  fontFamily: '"Geist", "Inter", system-ui, sans-serif',
                  fontWeight: 500,
                  fontSize: '14px',
                  padding: '14px',
                  borderRadius: '6px',
                  cursor: submitting ? 'default' : 'pointer',
                  transition: 'background 0.3s ease',
                  opacity: submitting ? 0.5 : 1,
                }}
              >
                {submitting ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <p style={{ marginTop: '24px', textAlign: 'center' }}>
              <Link to="/login" style={{
                color: '#e8b547',
                fontSize: '13px',
                fontFamily: '"Geist", "Inter", system-ui, sans-serif',
                textDecoration: 'none',
              }}>
                Back to sign in
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
